import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  r
} from "./chunk.4JTBA2KG.js";

// src/components/progress-dots/progress-dots.styles.ts
var progress_dots_styles_default = r` ${component_styles_default} :host { display: contents; } .progress-dots { display: flex; flex-direction: row; align-items: center; spacing: var(--sl-spacing-small); } `;

export {
  progress_dots_styles_default
};
